/**
 * Trusted-device token for SMS MFA (30-day remember).
 * Keyed per email so multiple accounts on one browser stay separate.
 * Logout must NOT clear this — device stays trusted per API docs.
 */

const storageKey = (email) => {
  const normalized = String(email || "")
    .toLowerCase()
    .trim();
  return normalized ? `mfa_device_token:${normalized}` : null;
};

export const getMfaDeviceToken = (email) => {
  const key = storageKey(email);
  if (!key) return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.token) return null;
    if (parsed.expiresAt) {
      const exp = new Date(parsed.expiresAt).getTime();
      if (Number.isFinite(exp) && exp <= Date.now()) {
        localStorage.removeItem(key);
        return null;
      }
    }
    return parsed.token;
  } catch {
    return null;
  }
};

export const saveMfaDeviceToken = (email, token, expiresAt) => {
  const key = storageKey(email);
  if (!key || !token) return;
  try {
    localStorage.setItem(
      key,
      JSON.stringify({
        token,
        expiresAt: expiresAt || null,
        savedAt: new Date().toISOString(),
      })
    );
  } catch {
    // ignore quota / private mode
  }
};

export const clearMfaDeviceToken = (email) => {
  const key = storageKey(email);
  if (!key) return;
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
};
